/** Fired when mock credit ticket counts may have changed (refresh admin sidebar badge). */
export const MOCK_CREDIT_TICKETS_UPDATED_EVENT = 'naati:mock-credit-tickets-updated';

export function notifyMockCreditTicketsUpdated(): void {
  window.dispatchEvent(new CustomEvent(MOCK_CREDIT_TICKETS_UPDATED_EVENT));
}
